import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { getCollections } from '../../clients/ecosystemClient';
export const fetchCollections = createAsyncThunk('collections/fetchAll', () => {
  return getCollections().then(response => response.collections);
});
const initialState = {
  list: [],
  requestState: RequestStates.UNINITIALIZED
};
export const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCollections.pending, state => {
      state.requestState = RequestStates.PENDING;
    }).addCase(fetchCollections.fulfilled, (state, action) => {
      state.requestState = RequestStates.SUCCEEDED;
      state.list = action.payload;
    }).addCase(fetchCollections.rejected, state => {
      state.requestState = RequestStates.FAILED;
    });
  }
});
export default collectionsSlice.reducer;
export const selectCollections = state => state.collections.list;
export const selectCollectionSlugs = state => state.collections.list.map(collection => `/${collection.publishedListing.slug}`);
export const selectDisplayedCollections = state => state.collections.list.filter(collection => collection.publishedListing.displayed);
export const selectCollectionById = id => state => state.collections.list.find(collection => collection.id === id);